export default function Footer() {
  return (
    <footer className="bg-secondary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/156395ee-9c05-4e2d-9b8e-de51476e9fd3.png"
              alt="Bridgend Electricians"
              className="h-16 w-auto mb-6"
            />
            <p className="text-white/70 text-sm mb-4">
              NAPIT approved electricians serving Bridgend and South Wales with professional, reliable electrical services.
            </p>
            <div className="flex space-x-4">
              <a
                href="http://facebook.com/megalecelectricalsolutions"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-primary/20 rounded-full transition-all cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg text-primary"></i>
              </a>
              <a
                href="http://instagram.com/megalec_electrical"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-primary/20 rounded-full transition-all cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-lg text-primary"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 font-display text-primary">Our Services</h4>
            <ul className="space-y-3">
              <li className="text-white/70 hover:text-primary text-sm transition-colors">
                Electrical Installations
              </li>
              <li className="text-white/70 hover:text-primary text-sm transition-colors">
                Rewiring Services
              </li>
              <li className="text-white/70 hover:text-primary text-sm transition-colors">
                Consumer Unit Upgrades
              </li>
              <li className="text-white/70 hover:text-primary text-sm transition-colors">
                EV Charger Installation
              </li>
              <li className="text-white/70 hover:text-primary text-sm transition-colors">
                EICR Testing
              </li>
              <li className="text-white/70 hover:text-primary text-sm transition-colors">
                Emergency Electrician
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 font-display text-primary">Service Areas</h4>
            <ul className="space-y-3">
              <li className="text-white/70 hover:text-primary text-sm transition-colors">
                Bridgend
              </li>
              <li className="text-white/70 hover:text-primary text-sm transition-colors">
                Cardiff
              </li>
              <li className="text-white/70 hover:text-primary text-sm transition-colors">
                Newport
              </li>
              <li className="text-white/70 hover:text-primary text-sm transition-colors">
                Swansea
              </li>
              <li className="text-white/70 hover:text-primary text-sm transition-colors">
                South Wales
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6 font-display text-primary">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <i className="ri-map-pin-fill text-primary mt-1 mr-3"></i>
                <span className="text-white/70 text-sm">
                  35 Dwynwen Road
                  <br />
                  Broadlands, Bridgend
                  <br />
                  CF31 5FD
                </span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-fill text-primary mr-3"></i>
                <a
                  href="tel:01656497474"
                  className="text-white/70 hover:text-primary text-sm transition-colors cursor-pointer"
                >
                  01656 497474
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-fill text-primary mr-3"></i>
                <a
                  href="mailto:mega-lec@outlook.com"
                  className="text-white/70 hover:text-primary text-sm transition-colors cursor-pointer"
                >
                  mega-lec@outlook.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/50 text-sm">
            © 2025 Bridgend Electricians. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
